import script from "./PaginationMixin.vue?vue&type=script&lang=js"
export * from "./PaginationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__